import { Directive, OnInit } from '@angular/core';

import styles from './VbBtn.Directive.module.less';

@Directive({
	selector: '[vbBtnLink]',
	host: {
		'[class]': 'hostClass'
	},
	standalone: false
})
export class VbBtnLinkDirective implements OnInit {
	public hostClass;

	public ngOnInit() {
		this.hostClass = `btn ${styles.vbBtn} ${styles.btnLink}`;
	}
}
